<template>
    <div class='text-left padding-only-left'>
        <div>
            <div id="borderBottomTabs2" class="borderBottomTabs"></div>
            <v-tabs
                v-resize="onResize"
                height="50px"
                class="headerTabs"
                color="black"
                slider-size="4" 
                v-model="tab"
                show-arrows
            >
                <v-tab class="cadastrosTab" id="clientes" @click="changeRouter('/clientes')">
                    <span>{{labels.clientes}}</span>
                </v-tab>
                <v-tab class="cadastrosTab" id="produtos" @click="changeRouter('/produtos')">
                    <span>{{labels.produtos}}</span>
                </v-tab>
                <v-tab class="cadastrosTab" id="usuarios" @click="changeRouter('/usuarios')">
                    <span>{{labels.usuarios}}</span>
                </v-tab>
                <v-tab class="cadastrosTab" id="atendimentos_situacoes" @click="changeRouter('/atendimentos_situacoes')">
                    <span>{{labels.atendimentos}}</span>
                </v-tab>
                <v-tab class="cadastrosTab" id="idiomas" @click="changeRouter('/idiomas')">
                    <span>{{labels.idiomas}}</span>
                </v-tab>
                <v-tab class="cadastrosTab" id="setores" @click="changeRouter('/setores')">
                    <span>{{labels.setores}}</span>
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item style="padding: 6px;">
                    <router-view />
                </v-tab-item>
                <v-tab-item style="padding: 6px;">
                    <router-view />
                </v-tab-item>
                <v-tab-item style="padding: 6px;">
                    <router-view />
                </v-tab-item>
                <v-tab-item style="padding: 6px;">
                    <router-view />
                </v-tab-item>
                <v-tab-item style="padding: 6px;">
                    <router-view />
                </v-tab-item>
                <v-tab-item style="padding: 6px;">
                    <router-view />
                </v-tab-item>
            </v-tabs-items>
        </div>
    </div>
</template>

<script>
import translate from '../../../../src/plugins/translate'

export default {
    name: 'Cadastros',
    components: {},
    data() {
        return {
            tab:null,
            labels: {
                clientes: translate('Clientes', 'Cadastros'),
                produtos: translate('Produtos', 'Cadastros'),
                usuarios: translate('Usuários', 'Cadastros'),
                atendimentos: translate('Atendimentos', 'Cadastros'),
                idiomas: translate('Idiomas', 'Cadastros'),
                setores: translate('Setores', 'Cadastros')
            }
        }
    },
    watch:{
        $route (to){
            this.$nextTick(function(){
                let el = document.getElementById(`${to.path.slice(1)}`)
                el.click()
            })
        }
    },
    methods: {
        onResize () {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
            this.buildborderTabs()
        },
        changeRouter(route) {
            if(window.location.pathname != route) this.$router.push(route)
        },
        buildborderTabs() {
            var allTabs = document.getElementsByClassName('cadastrosTab')
            var widthBorderBoddom = 0
            allTabs.forEach(function(tab){
                widthBorderBoddom += tab.offsetWidth
            })
            let element = document.getElementById('borderBottomTabs2')
            this.$nextTick(function(){
                element.style.width = `${widthBorderBoddom}px`
            })
        }
    },
    mounted() {
        setTimeout(function(){
            let el = document.getElementById(`${window.location.pathname.slice(1)}`)
            el.click()
        },120)
        this.onResize()
    }

}
</script>
<style scoped>
.headerPage{
    height: 2rem;
}
.padding-only-left{
    padding: 0 0 0 10px;
}
.titlePage{
    font-size: 16px;
    font-weight: 700;
}
.el-tabs__item.is-active{
    color:black !important;
}
.el-tabs__active-bar{
    background-color: #000000 !important;
}
.headerTabs{
    margin-bottom: 1em;
}
.cadastrosTab > span{
    font-weight: bolder !important;
}
.borderBottomTabs{
    border-bottom: 4px solid #80808052;
    position: relative;
    top: 50px;
    width: 1px;
    z-index: 1;
    border-radius: 50px;
}
</style>
